import React from "react";

function CgvPage() {
  const containerStyle = {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "2rem",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.5",
  };

  const headingStyle = {
    marginTop: "2rem",
    marginBottom: "1rem",
    fontSize: "1.3rem",
    fontWeight: "bold",
  };

  return (
    <div style={containerStyle}>
      <h1>Conditions Générales de Vente (CGV)</h1>

      <h2 style={headingStyle}>ARTICLE 1. Champ d’application</h2>
      <p>
        Les présentes conditions générales de vente (les « CGV ») sont applicables à toute Commande
        Validée sur le site <strong>www.balteemobility.com</strong> (le « Site ») exploité par
        <strong> BALTEE</strong>, société par actions simplifiées au capital de 18 011,00 €,
        immatriculée au RCS de RENNES sous le n°913 340 691, dont le siège social est Place du
        Granier – 35135 CHANTEPIE (ci-après désigné « BALTEE »), mais également tout site internet
        d’une société partenaire de Baltee avec laquelle un accord de distribution a été conclu et
        toute personne (ci-après le « Client »). Par commodité, il ne sera fait référence qu’au Site
        dans les présentes CGV, étant entendu que cette mention est applicable tant au Site
        qu’aux sites partenaires.
      </p>
      <p>
        Tout Contrat implique l’adhésion pleine et entière du Client aux présentes CGV, dont le
        Client déclare avoir parfaitement connaissance, lesquelles font échec à l’application de
        toute autre condition, notamment les conditions générales du Client, sauf accord expresse et
        écrit préalable de BALTEE.
      </p>
      <p>
        Les CGV peuvent être modifiées à tout moment par BALTEE. Les modifications sont opposables
        au Client dès qu’il en a eu connaissance et qu’il n’a pas expressément manifesté sa volonté
        de maintenir les CGV initiales dans un délai de 10 jours à compter du jour où il en a
        connaissance.
      </p>

      <h2 style={headingStyle}>ARTICLE 2. Définitions</h2>
      <p>
        Les termes et expressions utilisés dans les CGV et précédés d’une majuscule, tant au
        singulier qu’au pluriel, ont la signification suivante :
      </p>

      <ul style={{ marginLeft: "1.5rem" }}>
        <li>
          <strong>« Client »</strong> : désigne la personne achetant le Matériel aux termes du
          Contrat
        </li>
        <li>
          <strong>« Commande »</strong> : désigne le choix du Client pour l’achat avant achat
          pouvant être enregistrée pour une durée indéterminée dans l’historique du compte client
          jusqu’à sa suppression par le Client
        </li>
        <li>
          <strong>« Commande Validée »</strong> : désigne la commande effectivement validée par le
          Client en contrepartie de laquelle le Client a versé le prix d’achat proposé
        </li>
        <li>
          <strong>« Contrat »</strong> : désigne le contrat conclu entre BALTEE et le Client et
          constitué de l’ensemble des documents contractuels visés à l’article 3 ci-dessous
        </li>
        <li>
          <strong>« Date de Livraison »</strong> : désigne la date de livraison du Matériel telle
          que visée sur le bon de livraison
        </li>
        <li>
          <strong>« Matériel »</strong> : désigne le matériel propriété de BALTEE mentionné sur le
          Site et qui est vendu au Client aux termes du Contrat
        </li>
        <li>
          <strong>« Notice d’utilisation »</strong> : désigne la notice d’utilisation fournie avec
          le Matériel cédé qui permet au Client de découvrir toutes les fonctionnalités du Matériel
          ainsi que le guide d’utilisation et les recommandations d’usage
        </li>
        <li>
          <strong>« Partie »</strong> : désigne individuellement BALTEE ou le Client
        </li>
        <li>
          <strong>« Prix »</strong> : désigne le prix total du Matériel visé sur le Site
        </li>
      </ul>

      <h2 style={headingStyle}>ARTICLE 3. Documents contractuels</h2>
      <p>
        Le Contrat est formé, de manière indivisible, des documents contractuels suivants :
        </p>
        <ul style={{ marginLeft: "1.5rem" }}>
            <li>La facture émise par BALTEE ;</li>
            <li>Les avenants éventuels ;</li>
            <li>Les présentes CGV ;</li>
            <li>La Notice d’utilisation.</li>
        </ul>
        <p> 
        En cas de contradiction, d’ambiguïté ou de divergence entre les documents contractuels,
        chaque document prévaut sur le suivant dans l'ordre où ils sont énumérés ci-dessus.
      </p>
      <p>
        Le Contrat exprime l'intégralité de l'accord conclu entre les Parties, à l’exclusion de tous
        autres documents, prospectus, catalogues techniques ou commerciaux qui n’ont qu’une valeur
        indicative et prévaut sur tout échange et/ou accord antérieur, de quelque nature que ce
        soit.
      </p>

      <h2 style={headingStyle}>ARTICLE 4. Objet du contrat</h2>
      <p>
        Le Contrat a pour objet de définir les conditions dans lesquelles BALTEE vend le Matériel au
        Client. Le Client reconnaît avoir vérifié l’adéquation du Matériel à ses besoins. II assume
        pleinement la responsabilité de son choix à l'égard de BALTEE.
      </p>

      <h2 style={headingStyle}>ARTICLE 5. Formation du contrat</h2>
      <p>
        Le Contrat n’est formé que par l’acceptation expresse du Contrat par le Client. Le Contrat
        ne pourra être modifié ou complété que par voie d’avenant écrit et signé par les Parties.
      </p>
      <p>
        Le Client ne peut annuler sa Commande Validée que si cette annulation est expressément
        acceptée par écrit par BALTEE qui se réservera le droit de facturer des frais d’annulation
        d’un montant correspondant aux dépenses engagées par BALTEE pour le commencement d’exécution
        de la commande Validée, sans préjudice des stipulations prévues à l’article 16 ci-après.
      </p>

      <h2 style={headingStyle}>ARTICLE 6. Entrée en vigueur</h2>
      <p>
        À compter de la confirmation de la Commande Validée, BALTEE s’engage à livrer le Client et
        le Client s’engage à régler le prix conformément aux stipulations ci-après.
      </p>

      <h2 style={headingStyle}>ARTICLE 7. Livraison des Matériels</h2>
      <p>
        BALTEE détermine librement les modalités de transport pour la livraison du Matériel et donne
        au Client l’information sur le prestataire choisi (le cas échéant), le délai et le coût. Les
        délais de livraison sont purement indicatifs et BALTEE n’est pas responsable des retards de
        livraison.
      </p>
      <p>
        Le Client s’engage à ce que le lieu de livraison du Matériel permette la réalisation de
        celle-ci sans risques ni dangers pour le livreur.
      </p>
      <p>
        À compter de la Date de Livraison, le Client supportera tous les risques de perte ou
        d'endommagement du Matériel nonobstant l’éventuel exercice du Droit de rétractation prévu
        ci-après.
      </p>

      <h2 style={headingStyle}>ARTICLE 8. Obligations du Client</h2>
      <p>
        Le Client s’engage à ne pas intervenir lui-même sur le Matériel au cours de sa livraison. Il
        s’engage à ne pas modifier, effacer ou supprimer les logos et étiquettes de BALTEE sur le
        Matériel. Le Client s’engage à ne pas utiliser les éléments du Contrat à des fins
        commerciales.  
        Le Client s’engage par ailleurs à respecter le Code de la route et toutes les prescriptions
        légales, réglementaires contraignantes ou indicatives en matière de sécurité routière afin
        d’assurer la sécurité de sa personne et/ou de ses biens, ainsi que celle de tous les
        usagers. L’acquisition du Matériel ne dispense pas de cette vigilance.
      </p>

      <h2 style={headingStyle}>ARTICLE 9. Modalités financières</h2>
      <p>
        En contrepartie de la vente du Matériel, le Client paiera à BALTEE le Prix. Le Prix
        s’entend hors taxes et n’intègre pas les frais (à l’exception des frais de transport de
        livraison) éventuellement exposés par BALTEE pour l'exécution du Contrat, que le Client
        devra lui rembourser à première demande. La devise applicable au présent Contrat est
        l’Euro.
      </p>

      <h2 style={headingStyle}>ARTICLE 10. Droit d’auteur</h2>
      <p>
        Nonobstant toute clause contraire, BALTEE ne concède au Client aucun droit d’auteur.
        L’internaute s’engage à indemniser BALTEE de tout préjudice, direct ou indirect, subi par
        BALTEE du fait du non-respect par le Client de ses droits d’auteur.
      </p>

      <h2 style={headingStyle}>ARTICLE 11. Responsabilité</h2>
      <p>
        La responsabilité de BALTEE à l’égard du Client est exclue pour tout dommage subi par le
        Client qui :  
      </p>
        <ul style={{ marginLeft: "1.5rem" }}>
          <li>
            ne serait pas une suite immédiate et directe de l’inexécution du Contrat par BALTEE ; ou
          </li>
          <li>
            serait causé par le non-respect d'une obligation du Client, telle qu’une mauvaise
            utilisation et/ou entretien du Matériel ou le non-respect des consignes de la Notice
            d’utilisation ; ou
          </li>
          <li>
            serait causé par une faute, négligence, omission du Client ou d’un tiers sur lequel
            BALTEE n'a aucun pouvoir de contrôle ou de surveillance ; ou
          </li>
          <li>
            serait causé par la réalisation d'un risque inconnu en l'état actuel de la technique au
            moment de la survenance du dommage.
          </li>
        </ul>
      <p>
        BALTEE ne saurait être tenue pour responsable des dommages résultant d’une mauvaise
        utilisation du Matériel acheté. De même, BALTEE ne saurait être engagée pour tous les
        inconvénients ou dommages inhérents à l'utilisation du réseau Internet (rupture de service,
        intrusion extérieure, virus informatiques, défaillance de l’hébergeur…).
      </p>
      <p>
        Le Client devra, en tant que de besoin, souscrire et maintenir en cours de validité les
        polices d’assurance nécessaires pour garantir les éventuels dommages aux biens ou aux
        personnes qui pourraient survenir dans le cadre de l’utilisation du Matériel. Le Client et
        ses assureurs, dont il se porte fort, renoncent à former une réclamation à l’encontre de
        BALTEE et/ou ses assureurs au-delà des exclusions et limitation de responsabilité prévues au
        Contrat.
      </p>
      <p>
        Le Client se reconnaît ainsi seul responsable de l’utilisation du Matériel vendu et décharge
        BALTEE de toute responsabilité sur cette utilisation en s’engageant à respecter la Notice
        d’utilisation pour l’utilisation, l’entretien et la réparation du Matériel.
      </p>

      <h2 style={headingStyle}>ARTICLE 12. Garanties</h2>
      <p>
        Baltee garantit le B01 contre les défauts de défaillances éventuelles résultant de sa
        fabrication pendant une durée d’un an à compter de la date d’achat initial à Baltee. Cette
        garantie exclut expressément l’usure normale, les dommages accidentels ou l’utilisation du
        B01 non-conforme à la Notice d’utilisation et/ou toute défaillance liée au réseau et/ou au
        smartphone de l’utilisateur.
      </p>
      <p>
        Pour bénéficier de cette garantie, le Client doit adresser par courrier recommandé uniquement
        (i) le Matériel défaillant ainsi que (ii) la preuve d’acquisition du Matériel à Baltee, au
        service après-vente Baltee dans un délai maximum de 60 jours à compter du premier
        dysfonctionnement. Le Matériel sera soumis à une analyse dans un délai de 45 jours maximum
        afin de vérifier l’applicabilité de la garantie. L’application de la garantie n’est
        effective qu’en cas de retour de Baltee en ce sens auprès du Client. À défaut, la garantie
        n’aura pas vocation à s’appliquer.
      </p>

      <h2 style={headingStyle}>ARTICLE 13. Commande</h2>
      <p>
        Le Client peut réaliser sa Commande sur Internet via le Site.
        <br />
        Pour passer une Commande sur le Site, le Client doit respecter les étapes suivantes :
      </p>
      <ol style={{ marginLeft: "1.5rem" }}>
        <li>Identification du Client ;</li>
        <li>Sélection d'un Matériel ;</li>
        <li>Validation du panier et finalisation de la Commande ;</li>
        <li>
          Paiement : Le Client choisit le mode de paiement et procède au règlement. La Commande est
          réalisée dès confirmation du paiement et clic sur « PAYER », matérialisant l’acceptation
          définitive du Client au Contrat.
        </li>
        <li>
          Confirmation de Commande : la Commande du client est confirmée par BALTEE par l’envoi
          d’un courriel électronique récapitulant le contenu de la Commande. Cet e-mail confirme
          l’existence d’une Commande Validée correspondant à l’achat.
        </li>
      </ol>
      <p>
        Il appartient au Client de vérifier l'exactitude de la Commande et de signaler immédiatement
        toute erreur, la confirmation valant signature et acceptation des opérations. Toute Commande
        passée constitue la formation d'un contrat conclu à distance entre le Client et BALTEE.
      </p>
      <p>
        Le mail de confirmation constitue le justificatif de la Commande Validée et doit être
        conservé par le Client comme preuve d’achat.
      </p>

      <h2 style={headingStyle}>ARTICLE 14. Force Majeure</h2>
      <p>
        Aucune Partie ne sera responsable de la non-exécution totale ou partielle de ses obligations
        due à un événement constitutif d'un cas de force majeure au sens de l’article 1218 du code
        civil et de la jurisprudence. Sont assimilées à des cas de force majeure, lorsqu’elles
        paralysent l’exécution du Contrat, les circonstances suivantes : grèves, conflit de
        travail, lock-out, pénurie de matière première, grève des transporteurs, fait du prince,
        insurrection, attentat, guerre, incendie, catastrophes naturelles et épidémie mondiale ayant
        entraîné des mesures de confinement.
      </p>

      <h2 style={headingStyle}>ARTICLE 15. Résiliation pour manquement</h2>
      <p>
        En cas de manquement par l'une des Parties à l'une de ses obligations essentielles, l'autre
        Partie pourra la mettre en demeure, par lettre recommandée avec accusé de réception, de
        réparer ce manquement dans un délai maximum de dix (10) jours, en précisant qu’à défaut, le
        Contrat pourra être résilié. Si, à l’issue de ce délai, le manquement n’a pas été réparé,
        l’autre Partie pourra prononcer la résiliation du Contrat par lettre recommandée AR, sans
        préjudice des dommages et intérêts éventuels.
      </p>

      <h2 style={headingStyle}>ARTICLE 16. Divers et droit de rétractation</h2>
      <h3>16.1 Indépendance des Parties</h3>
      <p>
        Aucune disposition du Contrat ne permet de considérer BALTEE comme un agent, un mandataire,
        un représentant légal, un associé, un auxiliaire ou un employé du Client.
      </p>

      <h3>16.2 Nullité partielle</h3>
      <p>
        Au cas où l’une quelconque des clauses du présent Contrat serait déclarée nulle, la nullité
        de la clause n’entraînerait pas celle du Contrat dont toutes les autres dispositions
        demeureraient en vigueur. Les Parties s’efforceraient de remplacer la clause annulée par une
        clause valable ayant les mêmes effets juridiques et commerciaux.
      </p>

      <h3>16.4 Élection de domicile</h3>
      <p>
        Tout changement d’adresse ou d’identité du correspondant de l’une des Parties devra être
        communiqué sans délai à l’autre Partie.
      </p>

      <h3>16.5 Non-renonciation</h3>
      <p>
        Le fait pour une Partie de ne pas se prévaloir de la stricte application de l’une des
        dispositions du Contrat ne saurait être considéré comme une renonciation tacite au bénéfice
        de cette disposition ou de tout autre manquement similaire.
      </p>

      <h3>16.5 Droit de rétractation</h3>
      <p>
        Le Client, s’il est consommateur au sens de l’article liminaire du Code de la consommation,
        bénéficie d’un droit de rétractation dans les conditions des articles L.221-18 dudit Code.
        Ce droit ne s’applique qu’au Client défini comme consommateur.  
        Le Client dispose d’un délai de 14 jours pour exercer ce droit, à compter de la livraison
        des Matériels. Si le délai expire un samedi, un dimanche ou un jour férié, il est prorogé
        jusqu’au premier jour ouvrable suivant.  
        Dans le cas d'une Commande Validée portant sur plusieurs Matériels livrés séparément ou d'un
        Matériel composé de lots, le délai court à compter de la réception du dernier bien.
      </p>
      <p>
        Le Client exerce son droit de rétractation en informant le Vendeur de sa décision
        (formulaire de rétractation ou autre déclaration dénuée d'ambiguïté) avant l'expiration du
        délai. La charge de la preuve de l'exercice du droit de rétractation pèse sur le Client.
      </p>
      <p>
        L'exercice du droit de rétractation met fin à l'obligation d’exécuter le Contrat. Le Client
        restitue les Matériels sans retard excessif et au plus tard dans les 14 jours suivant la
        communication de sa décision. Les coûts de renvoi sont à la charge du Client, qui est
        responsable de leur acheminement.  
        La responsabilité du Client peut être engagée en cas de dépréciation des Matériels résultant
        de manipulations autres que celles strictement nécessaires pour en établir la nature, les
        caractéristiques et le bon fonctionnement. Le Matériel doit être restitué complet
        (accessoires, notice…), accompagné de la facture d’achat.
      </p>
      <p>
        Lorsque le droit de rétractation est exercé, le Vendeur rembourse le Client de la totalité
        des sommes versées, y compris les frais de livraison (hors supplément de livraison plus
        coûteux) sans retard injustifié et au plus tard dans les 14 jours suivant la date à laquelle
        il est informé de la décision du Client. Le Vendeur peut différer le remboursement jusqu'à
        récupération des biens ou preuve de leur expédition.  
        Le remboursement est effectué selon le même mode de paiement que celui utilisé par le
        Client, sauf impossibilité technique. Le Client qui a bénéficié d'un avantage promotionnel
        sera remboursé au prix effectivement payé.
      </p>

      <h2 style={headingStyle}>ARTICLE 17. Droit applicable et règlement des litiges</h2>
      <p>
        Le Contrat est régi par le droit français.  
        En cas de litige, le Client devra soumettre préalablement sa réclamation au service clients
        de BALTEE. À défaut de réponse ou de règlement amiable sous 20 jours ouvrés, l’Internaute
        pourra saisir la juridiction compétente.
      </p>
      <p style={{ fontWeight: "bold" }}>
        TOUS LES DIFFÉRENDS ENTRE LES PARTIES AUXQUELS POURRAIENT DONNER LIEU LA CONCLUSION
        L’INTERPRÉTATION OU L’EXÉCUTION DU CONTRAT SERONT RÉGLÉS À L’AMIABLE PAR LES PARTIES ET, EN
        CAS DE DÉSACCORD PERSISTANT, SERONT DE LA COMPÉTENCE EXCLUSIVE DU TRIBUNAL DE COMMERCE DE
        RENNES.
      </p>
      <p>
        Cette clause s’applique même en cas de référé, de demande incidente ou de pluralité de
        défendeurs.
      </p>
      <p>
        DE CONVENTION EXPRESSE ET EN APPLICATION DE L’ARTICLE 2254 DU CODE CIVIL, LE DÉLAI DE
        PRESCRIPTION DE L’ACTION EN RESPONSABILITÉ DU CLIENT CONTRE BALTEE EST PORTÉ À UN AN À
        COMPTER DE LA SURVENANCE DU DOMMAGE.
      </p>
    </div>
  );
}

export default CgvPage;
